import { Action, createReducer, on } from '@ngrx/store';
import { GreenIdConsentModel, GreenIdModel, IGreenIdState } from './state';
import {
  createFormGroupState,
  onNgrxForms, onNgrxFormsAction, SetValueAction
} from 'ngrx-forms';
import { ConsentFailedAction, RecordConsentAction, RequestVerificationCodeAction, RequestVerifiedAction, ResponseConsentAction, ResponseVerificationCodeAction, ResponseVerifiedAction, ScriptLoadedAction, UpdateOverallStatusAction } from './actions';
export const greenIdFormName = 'greenIdForm';
export const greenIdConsentFormName = 'greenIdConsentForm';

export const homeState: IGreenIdState = {
  model: new GreenIdModel(),
  isLoading: false,
  submittedDate: null,
  scriptLoaded: false,
  member: null,
  consentForm: createFormGroupState(greenIdConsentFormName, new GreenIdConsentModel()),
  consentSaving: false,
  consentError: false,
  consentCompletedDate: null
};

const reducer = createReducer(homeState,
  onNgrxForms(),
  onNgrxFormsAction(SetValueAction, (state, action) => {
    return state;
  }),
  on(ResponseVerificationCodeAction, (state, { data }) => {
    var m = null;
    if (data.member) {
      m = createFormGroupState(greenIdFormName, data.member);
    }
    return {
      ...state,
      member: m,
      model: data,
      isLoading: false
    };
  }),
  on(ScriptLoadedAction, (state, { }) => {
    return {
      ...state,
      scriptLoaded: true
    };
  }),
  on(UpdateOverallStatusAction, (state, { status }) => {
    return {
      ...state,
      model: {
        ...state.model,
        overallStatus: status
      }
    };
  }),
  on(RequestVerifiedAction, (state, { account, verificationId }) => {
    return {
      ...state,
      model: {
        ...state.model,
        verificationId: verificationId
      }
    };
  }),
  on(RequestVerificationCodeAction, (state, { account }) => {
    return {
      ...state,
      isLoading: true,
      submittedDate: null
    };
  }),
  on(ResponseVerifiedAction, (state, { data }) => {
    return {
      ...state,
      submittedDate: new Date()
    };
  }),
  on(RecordConsentAction, (state) => {
    return {
      ...state,
      consentSaving: true,
      consentError: false,
      consentCompletedDate: null
    };
  }),
  on(ResponseConsentAction, (state) => {
    return {
      ...state,
      model: {
        ...state.model,
        hasConsented: true
      },
      consentForm: createFormGroupState(greenIdConsentFormName, new GreenIdConsentModel()),
      consentSaving: false,
      consentError: false,
      consentCompletedDate: new Date()
    };
  }),
  on(ConsentFailedAction, (state) => {
    return {
      ...state,
      consentSaving: false,
      consentError: true
    };
  })

);

export function greenIdReducer(state: any | undefined, action: Action) {
  return reducer(state, action);
}
